import React from "react";
import '../../sass/components/_components.footerailabs.scss';
import twitter from '../../images/icon-twitter-black-v2.svg';
import linkedin from '../../images/icon-linkedin-black-v2.svg';
import facebook from '../../images/icon-facebook-black.svg';
import instagram from '../../images/icon-instagram-black.svg';
import planfulLogo from '../../images/planful-logo-latest-svg.svg';
import ailabsLogo from '../../images/ai-labs-logo.svg';
import MarketoFormComponent from '../marketo/marketoFormComponent';

const FooterAiLabs = () => {
    return (
        <div className="cp-footerAilabs">
            <div className="cp-footerAilabs__inner">
                <div className="cp-footerAilabs__inner-top l--flex">
                    <div className="cp-footerAilabs__inner-top-left">
                        <img src={ailabsLogo} alt="" />
                        <p>Leading the conversation on AI and finance innovation.</p>
                    </div>
                    <div className="cp-footerAilabs__inner-top-right">
                        <MarketoFormComponent formId="3854" />
                        <div className="l--socialIcons l--flex">
                            <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                <img loading="lazy" src={twitter} alt="Twitter" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                <img loading="lazy" src={linkedin} alt="LinkedIn" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                <img loading="lazy" src={facebook} alt="Facebook" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                <img loading="lazy" src={instagram} alt="Instagram" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="cp-footerAilabs__inner-bottom l--flex">
                    <a className="l--plogo" href="/"><img src={planfulLogo} alt="" /></a>
                    <div className="l--right l--flex">
                        <a href="https://planful.com/" target="_blank">Visit Planful.com</a>
                        <a href="https://planful.com/privacy-policy/" target="_blank"> Privacy Policy</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterAiLabs;